module.exports = __webpack_public_path__ + "static/media/tarra-h2h-picturemark-l.7f3e5725.svg";